module.exports = __webpack_public_path__ + "static/img/Logopurple.501e195.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Logopurple.png
// module id = CWfP
// module chunks = 1